import { Component, OnInit } from '@angular/core';
import { ApolloService } from '@src/app/services/apollo/apollo.service';
import { ScopeService } from '@src/app/services/scope/scope.service';
import { ExcelService } from '@src/app/services/excel/excel.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-ean',
  templateUrl: './ean.component.html',
  styleUrls: ['./ean.component.scss'],
  standalone: false,
})
export class EanComponent implements OnInit {
  availableEANs: number = 0;

  constructor(
    private _apolloService: ApolloService,
    private _scopeService: ScopeService,
    private _excelService: ExcelService,
    private _translateService: TranslateService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    await this._getNumberOfEANs();
  }

  async uploadEANList(event: any): Promise<void> {
    const files = event.target.files;
    try {
      const scope = this._scopeService.currentScope$.getValue()?.id;
      if (files.length > 0 && scope) {
        const data: string[] = await this._excelService.readEANXlsx$(files[0]);
        const retailer = await firstValueFrom(this._apolloService.getCurrentRetailer$());
        const uploadResult = await firstValueFrom(this._apolloService.uploadEANs$(data, retailer.id));
        if (uploadResult) {
          window.alert(this._translateService.instant('retailerData.excelUpload.success'));
          void this._getNumberOfEANs();
        } else {
          window.alert(this._translateService.instant('retailerData.excelUpload.failed'));
        }
      } else {
        window.alert(this._translateService.instant('retailerData.excelUpload.noFile'));
      }
    } catch (e) {
      window.alert(e instanceof Error ? e.message : e);
    }
  }

  private async _getNumberOfEANs(): Promise<void> {
    this.availableEANs = await firstValueFrom(this._apolloService.getFreeEANs$());
  }
}
